class FrontendConfigService {

    static getOptionsToast = () => {
        return {
            position: "top-right",
            timeout: 7000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.1,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
        }
    }

    static tryNotificationErrors(error){
        if(error.response){
            if((error.response.data||[]).length > 0){
                let messages = this.tryResonseErrorStringToJson(error.response.data)
                messages = messages[0]
                //context.commit('setNotifications', [{'tag':'warning', 'title':'', 'message': messages}])
                return {tag:'warning', message: messages}
            }else{ // valida se error.response é um objeto
                const keys = Object.keys(error.response.data)
                if (keys.length > 0){
                    for(let index of keys){
                        let msg = error.response.data[index]
                        return {tag:'error', message: msg}
                        /*
                        try{
                            //se for um array de string
                        }catch{
                            //index com multiplas mensagens de errors (atributos com valores em array)
                            let msg = error.response.data[index][0]
                            //context.commit('setNotifications', [{'tag':'warning', 'title':'', 'message':msg}])
                            return {tag:'warning', message: msg}
                        }*/
                    }
                }else{
                    return {tag:'error', message: error.response.status }
                }
            }
        }else{
            //context.commit('setNotifications', [{'tag':'error', 'title':'Falha na requisição', 'message':error.message}])
            return { tag:'error', message: error.message }
        }

    }

    static tryResonseErrorStringToJson(response){
        let mensagens = []
        try{
            let errors = response.map(obj =>{
                // Antes de realizar o parse para JSON alterar a string de aspas simples para aspas duplas
                return obj.replaceAll("'",'"')
            })
            //alterar de string para JSON
            errors = JSON.parse(errors)
            let keys = Object.keys(errors)
            mensagens = keys.map(obj =>{
                //Recuperar sempre a primeira mensagem de erro  dos objetos capturados pelas chaves
                return errors[obj][0]
            })
        }catch{
            console.error('errors',response)
        }
        return mensagens
    }    
}

export default FrontendConfigService